import { render, staticRenderFns } from "./GlossVariantCategorySelector.vue?vue&type=template&id=23ae3d61&"
import script from "./GlossVariantCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./GlossVariantCategorySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports